<template>
  <el-container class="app-wrapper">
    <!-- 顶部导航 -->
    <el-header height="60px" class="app-header">
      <div class="header-left">
        <div class="logo" @click="_toIndex">{{ systemInfo.systemSimpleTitle }}</div>
        <el-menu mode="horizontal" :default-active="activeMenu" class="header-menu" background-color="#199ED7"
                 text-color="#fff" active-text-color="#409EFF">
          <template v-for="(item, index) in catalogs">
            <el-menu-item :index="item.caId" v-if="!item.privId || hasPrivilege(item.privId)" :key="index"
                          @click="_changeMenuCatalog(item, true)">{{ getCatalogDisplayName(item) }}</el-menu-item>
          </template>
        </el-menu>
      </div>
      <div class="header-right">
        <!--        <el-dropdown @command="changeCommunity" v-if="storeInfo.storeTypeCd == '800900000003'" class="margin-right">-->
        <!--          <span class="user-info">-->
        <!--            {{ curCommunityName }}-->
        <!--            <i class="el-icon-arrow-down el-icon&#45;&#45;right"></i>-->
        <!--          </span>-->
        <!--          <el-dropdown-menu slot="dropdown">-->
        <!--            <el-dropdown-item :command="c" v-for="(c, index) in communitys" :key="index">{{ c.name }}</el-dropdown-item>-->
        <!--            <el-dropdown-item command="moreCommunity" class="moreCommunity">{{ $t('layout.moreCommunity')-->
        <!--              }}</el-dropdown-item>-->
        <!--          </el-dropdown-menu>-->
        <!--        </el-dropdown>-->
        <el-dropdown @command="handleCommand">
          <span class="user-info">
            {{ username }}
            <i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="logout">{{ $t('layout.logout') }}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <span class="margin-left">{{ systemInfo.version }}</span>

      </div>
    </el-header>

    <el-container>
      <!-- 左侧菜单 width="64px"-->
      <el-aside class="app-aside" width="80">
        <div class="vc-menu flex justify-start" id="menu-nav">
          <div class="vc-menu-main" v-if="menuTree && menuTree.length > 1">
            <ul>
              <template v-for="(menu, index) in menuTree">
                <li :key="index" v-if="menu.childs && menu.childs.length > 0" :class="{ active: menu.active }"
                    @click="switchMenu(menu)">
                  <i class="fa " v-bind:class="menu.icon"></i><span class="margin-left-xs">{{ menu.name }}</span>
                </li>
              </template>
            </ul>
          </div>
          <div class="vc-menu-sub" v-if="subMenus && subMenus.length > 0">
            <div class="vc-menu-sub-title">{{ curMenuName }}</div>
            <div class="vc-menu-sub-body">
              <ul>
                <template v-for="(subMenu, index) in subMenus">
                  <li :key="index" v-if="subMenu.isShow == 'Y'" :class="{ active: subMenu.active }"
                      v-on:click="_gotoPage(subMenu.href, subMenu.name)">
                    {{ subMenu.name }}
                  </li>
                </template>
              </ul>
            </div>
            <div class="vc-menu-sub-footer" @click="_closeSubMenu()">
              <i class="fa fa-dedent"></i>
            </div>
          </div>
        </div>
      </el-aside>

      <!-- 主要内容区 -->
      <el-main class="app-main">
        <router-view />
      </el-main>
    </el-container>
    <more-community ref="moreCommunity" />
    <view-menu-user-list ref="viewMenuUserModel" />
    <search-community-data-list ref="searchCommunityDataModel" />
  </el-container>
</template>

<script>
import { _getMenuCatalog, getMenuTree, jumpToMall, jumpToIot,jumpToFood } from '@/api/user/menuApi'
import { getStoreInfo } from "@/api/user/indexApi"
import { listSystemInfo } from '@/api/system/systemInfoManageApi'
import { deepCopy, setCurrentCommunity } from "@/utils/vc"
import { getCommunityName, _loadCommunityInfo } from '@/api/community/communityApi'
import moreCommunity from '@/components/community/moreCommunity.vue'
import viewMenuUserList from '@/components/system/viewMenuUserList.vue'
import searchCommunityDataList from '@/components/system/searchCommunityDataList.vue'
import { initSystem } from '@/api/util/vcApi'
import config from '@/conf/config'
import { buildEmergencyPlansMenuTree } from '@/views/layout/emergencyPlansMenu'
import {
  collectSmartTrafficRelocatedGroups,
  hasSmartTrafficContent,
  stripMenusRelocatedToSmartTraffic,
  SMART_TRAFFIC_VIRTUAL_ID
} from '@/views/layout/menuRelocation'
import { injectDataCenterReportExtras } from '@/views/layout/dataCenterMenuExtras'

const DATA_CENTER_VIRTUAL_ID = 'dataCenter'

// 前端自定义的“一级菜单 -> 菜单组”映射。
// 这些一级菜单不依赖后端目录，完全由前端维护，并按数组顺序展示。
const VIRTUAL_CATALOG_DEFINITIONS = [
  { id: 'smartOperation', titleKey: 'menuTopSmartOperation', menuKeys: ['menuGroupCommunity', 'menuGroupRepair', 'menuGroupInspection', 'menuGroupOffice', 'menuGroupReservation', 'menuGroupOa'] },
  { id: 'finance', titleKey: 'menuTopFinance', menuKeys: ['menuGroupFee'] },
  { id: 'asset', titleKey: 'menuTopAsset', menuKeys: ['menuGroupRoom'] },
  { id: 'leasing', titleKey: 'menuTopLeasing', menuKeys: ['menuGroupContract', 'menuGroupPurchase'] },
  { id: 'valueAdded', titleKey: 'menuTopValueAdded', menuKeys: ['menuGroupCoupon'] },
  { id: 'energyControl', titleKey: 'menuTopEnergyControl', menuKeys: ['menuGroupMachine'] },
  { id: 'smartTraffic', titleKey: 'menuTopSmartTraffic', menuKeys: ['menuGroupParking'] },
  { id: 'dataCenter', titleKey: 'menuTopDataCenter', menuKeys: ['menuGroupReport'] }
]

// 需要从顶部一级菜单中隐藏的目录名称（纯前端展示策略）。
const HIDDEN_TOP_MENU_NAMES = ['常用菜单', '搜索', '业务受理', ]

// 应急预案：与首页虚拟一级一起插入，紧跟 VIRTUAL_CATALOG_DEFINITIONS 之后
const EMERGENCY_PLANS_CATALOG = {
  caId: 'virtual_emergency_plans',
  titleKey: 'menuTopEmergencyPlans',
  virtualCatalog: true,
  virtualStaticEmergencyPlans: true,
  privId: '',
  url: '#'
}


export default {
  name: 'Layout',
  data() {
    return {
      catalogs: [],
      menuTree: [],
      subMenus: [],
      menuWidth: 80,
      menuId: '',
      curMenuName: '',
      activeMenu: '',
      activeSubMenu: 'communityList',
      searchText: '',
      username: '',
      homeCatalog: null,
      homeMenuTree: [],
      curCommunityName: '',
      communitys: [],
      storeInfo: {
        storeTypeCd: '',
        storeId: ''
      },
      systemInfo: {
        systemSimpleTitle: '',
        companyName: '',
        logoUrl: '',
        version: ''
      }
    }
  },
  created() {
    let _user = JSON.parse(localStorage.getItem('user'));
    this.username = _user.name
    this.systemInfo.version = config.version
    this.getSystemInfo()
    this._loadStoreInfo()
    this.loadCatalogs()
    this.curCommunityName = getCommunityName()
    this.loadCommunity()
    initSystem()
  },
  components: {
    moreCommunity,
    viewMenuUserList,
    searchCommunityDataList
  },
  methods: {
    async getSystemInfo() {
      const { data } = await listSystemInfo({ page: 1, row: 1 });
      this.systemInfo.systemSimpleTitle = data[0].systemSimpleTitle
      this.systemInfo.companyName = data[0].companyName
      this.systemInfo.logoUrl = data[0].logoUrl
    },
    async loadCommunity() {
      const { communitys } = await _loadCommunityInfo()
      this.communitys = communitys
      this.curCommunityName = getCommunityName()

    },
    async _loadStoreInfo() {
      this.loading = true
      try {
        const res = await getStoreInfo()
        deepCopy(res, this.storeInfo);
      } catch (error) {
        console.error('登录失败：', error)
      } finally {
        this.loading = false
      }

    },
    async loadCatalogs() {
      this.loading = true
      try {
        const res = await _getMenuCatalog()
        if (res.code != 0) {
          return;
        }
        // 先重组目录（首页拆分为虚拟一级菜单）
        const rebuiltCatalogs = this.rebuildCatalogs(res.data || []);
        // 去掉当前用户没有任何可见二级菜单的虚拟一级菜单
        this.catalogs = await this.filterCatalogsByMenuPermission(rebuiltCatalogs);
        if (this.catalogs && this.catalogs.length > 0) {
          this._changeMenuCatalog(this.catalogs[0])
        }
      } catch (error) {
        console.error('登录失败：', error)

      } finally {
        this.loading = false
      }
    },
    // 仅保留“存在至少一个可见菜单组”的虚拟一级菜单，避免空壳菜单显示出来。
    async filterCatalogsByMenuPermission(catalogs) {
      if (!this.homeCatalog) {
        return catalogs
      }
      const baseMenus = await this.ensureHomeMenuTree()
      return catalogs.filter(catalog => {
        if (!catalog.virtualCatalog) {
          return true
        }
        if (catalog.virtualMiscBucket) {
          return this.buildMiscVirtualMenuTree(baseMenus).length > 0
        }
        if (catalog.virtualStaticEmergencyPlans) {
          return true
        }
        if (catalog.caId === `virtual_${SMART_TRAFFIC_VIRTUAL_ID}`) {
          return hasSmartTrafficContent(
            baseMenus,
            key => this.getLangValuesByKey(key),
            name => this.normalizeMenuName(name)
          )
        }
        const matchedMenus = this.buildVirtualMenuTree(baseMenus, catalog.menuKeys || [])
        return matchedMenus.length > 0
      })
    },
    // 顶部一级菜单名称展示：
    // - 虚拟菜单：走 i18n key
    // - 原始菜单：沿用后端返回名称
    getCatalogDisplayName(_catalog) {
      if (_catalog.virtualCatalog && _catalog.titleKey) {
        return this.$t(`layout.${_catalog.titleKey}`)
      }
      return _catalog.name
    },
    // 重组一级菜单：
    // 1) 先过滤掉不需要展示的目录（常用菜单/搜索/业务受理）
    // 2) 找到“首页”目录
    // 3) 用前端维护的虚拟一级菜单替换「首页」；应急预案紧跟定义表之后；「其它功能」收纳未映射菜单组
    rebuildCatalogs(catalogs) {
      const visibleCatalogs = catalogs.filter(item => !this.shouldHideCatalog(item))
      const homeCatalog = this.findHomeCatalog(visibleCatalogs)
      this.homeCatalog = homeCatalog || null
      if (!homeCatalog) {
        return visibleCatalogs.some(c => c.caId === EMERGENCY_PLANS_CATALOG.caId)
          ? visibleCatalogs
          : visibleCatalogs.concat([{ ...EMERGENCY_PLANS_CATALOG }])
      }
      const virtualCatalogs = VIRTUAL_CATALOG_DEFINITIONS.map(def => ({
        caId: `virtual_${def.id}`,
        titleKey: def.titleKey,
        menuKeys: def.menuKeys,
        virtualCatalog: true,
        sourceCaId: homeCatalog.caId,
        privId: homeCatalog.privId,
        url: '#'
      }))
      virtualCatalogs.push({
        ...EMERGENCY_PLANS_CATALOG,
        sourceCaId: homeCatalog.caId,
        privId: homeCatalog.privId
      })
      virtualCatalogs.push({
        caId: 'virtual_misc',
        titleKey: 'menuTopMisc',
        menuKeys: [],
        virtualCatalog: true,
        virtualMiscBucket: true,
        sourceCaId: homeCatalog.caId,
        privId: homeCatalog.privId,
        url: '#'
      })
      const homeIndex = visibleCatalogs.findIndex(item => item.caId === homeCatalog.caId)
      const filteredCatalogs = visibleCatalogs.filter(item => item.caId !== homeCatalog.caId)
      filteredCatalogs.splice(homeIndex, 0, ...virtualCatalogs)
      return filteredCatalogs
    },
    async buildSmartTrafficMenuTree(menuKeys) {
      const baseMenus = await this.ensureHomeMenuTree()
      const workingMenus = JSON.parse(JSON.stringify(baseMenus))
      const relocatedGroups = collectSmartTrafficRelocatedGroups(
        workingMenus,
        key => this.getLangValuesByKey(key),
        name => this.normalizeMenuName(name)
      )
      const menuTree = this.buildVirtualMenuTree(workingMenus, menuKeys || [])
      const merged = menuTree.concat(relocatedGroups)
      merged.sort((a, b) => (a.seq || 0) - (b.seq || 0))
      return merged
    },
    // 是否命中顶部隐藏名单。
    shouldHideCatalog(catalog) {
      const hiddenNames = HIDDEN_TOP_MENU_NAMES.map(name => this.normalizeMenuName(name))
      return hiddenNames.includes(this.normalizeMenuName(catalog.name))
    },
    // 通过多语言文案匹配“首页”目录，兼容中英文环境。
    findHomeCatalog(catalogs) {
      const homeLabels = this.getLangValuesByKey('home')
      const lowerCaseLabels = homeLabels.map(label => label.toLowerCase())
      return catalogs.find(item => {
        const name = (item.name || '').trim().toLowerCase()
        return lowerCaseLabels.includes(name)
      }) || null
    },
    // 获取某个 i18n key 在多语言下的候选文本，用于菜单名称匹配。
    getLangValuesByKey(key) {
      const locales = ['zh', 'en']
      const values = locales.map(locale => {
        const localeLayout = ((this.$i18n.messages[locale] || {}).layout || {})
        return localeLayout[key]
      }).filter(Boolean)
      values.push(this.$t(`layout.${key}`))
      return Array.from(new Set(values.map(item => (item || '').trim()).filter(Boolean)))
    },
    // 菜单名称归一化，保证匹配稳定（去空格 + 小写）。
    normalizeMenuName(name) {
      return (name || '').trim().toLowerCase()
    },
    // 懒加载并缓存“首页”的菜单树。
    // 虚拟一级菜单都基于它进行前端重组，避免重复请求接口。
    async ensureHomeMenuTree() {
      if (this.homeMenuTree.length > 0) {
        return this.homeMenuTree
      }
      if (!this.homeCatalog) {
        return []
      }
      const res = await getMenuTree(this.homeCatalog)
      this.homeMenuTree = res.data || []
      return this.homeMenuTree
    },
    // 根据映射关系，从首页菜单树中抽取并重建当前虚拟一级菜单下的菜单组。
    // 展示顺序严格按 menuKeys，不按后端 seq 排序。
    buildVirtualMenuTree(allMenus, menuKeys) {
      const result = []
      const menuMap = {}
      allMenus.forEach(menu => {
        menuMap[this.normalizeMenuName(menu.name)] = menu
      })
      menuKeys.forEach(menuKey => {
        const langValues = this.getLangValuesByKey(menuKey)
        for (const value of langValues) {
          const matched = menuMap[this.normalizeMenuName(value)]
          if (matched) {
            result.push(JSON.parse(JSON.stringify(matched)))
            break
          }
        }
      })
      return result
    },
    // 已被 VIRTUAL_CATALOG_DEFINITIONS 各虚拟一级占用的首页菜单组 id
    collectAssignedHomeMenuIds(baseMenus) {
      const ids = new Set()
      VIRTUAL_CATALOG_DEFINITIONS.forEach(def => {
        this.buildVirtualMenuTree(baseMenus, def.menuKeys).forEach(m => ids.add(String(m.id)))
      })
      return ids
    },
    // 「其它功能」：首页下未被上述映射收走的菜单组（有子菜单的），按后端 seq 排序
    buildMiscVirtualMenuTree(baseMenus) {
      const assignedIds = this.collectAssignedHomeMenuIds(baseMenus)
      return baseMenus
        .filter(menu => !assignedIds.has(String(menu.id)) && menu.childs && menu.childs.length > 0)
        .sort((a, b) => (a.seq || 0) - (b.seq || 0))
        .map(menu => JSON.parse(JSON.stringify(menu)))
    },
    _changeMenuCatalog(_catalog, _isJump) {
      this.activeMenu = _catalog.caId;
      // 虚拟一级菜单：不走后端目录逻辑，直接走前端映射重组。
      if (_catalog.virtualCatalog) {
        this.loadVirtualMenuTree(_catalog)
        return
      }
      if (this._showModelDiv(_catalog)) {
        return;
      }
      if (_catalog.caId === '1') {
        this.$router.push('/#/pages/mall/product');
      }
      if (_catalog.url == 'IOT') {
        jumpToIot('/');
        return;
      }
      if (_catalog.url == 'MALL') {
        //获取用户名
        jumpToMall('/');
        return;
      }
      if (_catalog.url == 'FOOD') {
        //获取用户名
        jumpToFood('/');
        return;
      }
      console.log(_catalog)
      if (_catalog.url != '#' && _isJump) {
        this._gotoPage(_catalog.url, _catalog.name)
        //return;
      }
      this.loadMenuTree(_catalog)
    },
    // 加载虚拟一级菜单对应的左侧菜单：
    // - 先重建 menuTree
    // - 默认定位到第一个菜单组并进入其首个二级菜单
    async loadVirtualMenuTree(_catalog) {
      if (_catalog.virtualStaticEmergencyPlans) {
        this.menuTree = buildEmergencyPlansMenuTree()
      } else {
        const baseMenus = await this.ensureHomeMenuTree()
        if (_catalog.caId === `virtual_${SMART_TRAFFIC_VIRTUAL_ID}`) {
          this.menuTree = await this.buildSmartTrafficMenuTree(_catalog.menuKeys || [])
        } else if (_catalog.caId === `virtual_${DATA_CENTER_VIRTUAL_ID}`) {
          const workingMenus = JSON.parse(JSON.stringify(baseMenus))
          this.menuTree = injectDataCenterReportExtras(
            this.buildVirtualMenuTree(workingMenus, _catalog.menuKeys || []),
            key => this.getLangValuesByKey(key),
            name => this.normalizeMenuName(name)
          )
        } else if (_catalog.virtualMiscBucket) {
          const workingMenus = JSON.parse(JSON.stringify(baseMenus))
          stripMenusRelocatedToSmartTraffic(
            workingMenus,
            key => this.getLangValuesByKey(key),
            name => this.normalizeMenuName(name)
          )
          this.menuTree = this.buildMiscVirtualMenuTree(workingMenus)
        } else {
          const workingMenus = JSON.parse(JSON.stringify(baseMenus))
          stripMenusRelocatedToSmartTraffic(
            workingMenus,
            key => this.getLangValuesByKey(key),
            name => this.normalizeMenuName(name)
          )
          this.menuTree = this.buildVirtualMenuTree(workingMenus, _catalog.menuKeys || [])
        }
      }
      this.subMenus = []
      this.curMenuName = ''
      if (this.menuTree.length > 0) {
        this.switchMenu(this.menuTree[0])
      }
    },

    handleCommand(command) {
      if (command === 'logout') {
        // 处理退出登录

        localStorage.removeItem('token')
        localStorage.clear();
        this.$router.push('/login')
      } else if (command === 'zh' || command === 'en') {
        // 切换语言
        this.$i18n.locale = command
        localStorage.setItem('language', command)
      }
    },
    changeCommunity(community) {
      if (community == 'moreCommunity') {
        this.$refs.moreCommunity.open()
        return
      }
      setCurrentCommunity(community);
      this.curCommunityName = getCommunityName()
      window.location.href = "/"
    },
    handleMenuSelect(index) {
      // 处理菜单选择
      this.$router.push({ name: index })
    },
    loadMenuTree(_catalog) {
      getMenuTree(_catalog).then(res => {
        let _menus = res.data;
        _menus.sort(function (a, b) {
          return a.seq - b.seq
        });
        this.menuTree = _menus;
        if (this.homeCatalog && _catalog.caId === this.homeCatalog.caId) {
          this.homeMenuTree = JSON.parse(JSON.stringify(_menus))
        }
      })
    },
    switchMenu(_menu) {
      //设置菜单ID
      this.menuId = _menu.id;
      this.menuTree = this.refreshMenuActive(this.menuTree, _menu.id);

      if (_menu.directNavigate && _menu.childs && _menu.childs.length > 0) {
        this.subMenus = []
        this.curMenuName = ''
        this._gotoPage(_menu.childs[0].href, _menu.childs[0].name)
        return
      }

      this.subMenus = _menu.childs;
      console.log(this.subMenus)
      this.curMenuName = _menu.name;

      if (!_menu.childs || _menu.childs.length < 1) {
        return;
      }
      //选中第一个
      this._gotoPage(_menu.childs[0].href, _menu.childs[0].name);
      //vc._fix_height()
    },
    refreshMenuActive(jsonArray, _id) {
      for (let menuIndex = 0; menuIndex < jsonArray.length; menuIndex++) {
        if (jsonArray[menuIndex].childs) {
          let _childs = jsonArray[menuIndex].childs;
          _childs.sort(function (_child, _newChild) {
            return _child.seq - _newChild.seq
          });
          jsonArray[menuIndex].childs = _childs;
        }

        if (_id === jsonArray[menuIndex].id) {
          //如果当前本身是打开状态，说明 需要关闭
          jsonArray[menuIndex].active = true;
          continue;
        }
        jsonArray[menuIndex].active = false;
      }
      return jsonArray;
    },
    _setSelectedMenusChild(_href) {
      for (var menuIndex = 0; menuIndex < this.menuTree.length; menuIndex++) {
        if (this.menuTree[menuIndex].childs) {
          var _childs = this.menuTree[menuIndex].childs;
          for (var childIndex = 0; childIndex < _childs.length; childIndex++) {
            if (_href == _childs[childIndex].href) {
              this.menuTree[menuIndex].childs[childIndex].active = true;
            } else {
              this.menuTree[menuIndex].childs[childIndex].active = false;
            }
          }
        }
      }
      this.$forceUpdate();
    },
    _gotoPage(_href, _tabName) {
      console.log(_href, _tabName)
      // 子菜单默认选中
      this._setSelectedMenusChild(_href);
      if (_href.indexOf('.html') > -1) {
        window.open(_href, '_blank')
        return
      }
      if (_href.indexOf('/#/') > -1) {
        _href = _href.replace('/#/', '/')
      }

      this.$router.push(_href).catch(err => {
        // 忽略重复导航错误
        if (err.name !== 'NavigationDuplicated') {
          throw err
        }
      })
    },
    _showModelDiv: function (_catalog) {
      console.log(_catalog)
      if (_catalog.url.startsWith('?')) {
        let _modelName = _catalog.url.substring(1, _catalog.url.length);
        this.$refs[_modelName].open()
        return true;
      }
      return false;
    },
    _toIndex() {
      location.href = '/'
    },
    _closeSubMenu() {
      this.subMenus = []
      this.curMenuName = ''
    }

  }
}
</script>

<style lang="scss" scoped>
.app-wrapper {
  height: 100vh;
}

.app-header {
  background-color: #199ED7;
  color: #fff;
  padding: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header-left {
  display: flex;
  align-items: center;
}

.logo {
  width: 100px;
  height: 60px;
  line-height: 60px;
  text-align: center;
  font-size: 24px;
  font-weight: bold;
  //color: #409EFF;
  cursor: pointer;
}

.header-menu {
  border: none;
  background-color: #199ED7;
}

.header-right {
  display: flex;
  align-items: center;
  margin-right: 20px;
}

.margin-left {
  margin-left: 15px;
  color: #fff;
}

.user-info {
  color: #fff;
  cursor: pointer;
}

.app-aside {
  width: auto;
}

.menu-wrapper {
  height: 100%;
}

.el-menu-vertical {
  border: none;
}

.el-menu-vertical:not(.el-menu--collapse) {
  width: 200px;
}

.app-main {
  background-color: #f5f7fa;
  height: calc(100vh - 60px);
  padding: 0px;
}

:deep(.el-menu--horizontal) {
  border-bottom: none;
  background-color: #199ED7;
}

:deep(.el-menu-item) {
  height: 50px;
  line-height: 50px;
}

:deep(.el-menu--horizontal > .el-menu-item.is-active) {
  background-color: #6CABE0 !important;
  color: #fff !important;
}

:deep(.el-submenu__title) {
  height: 50px;
  line-height: 50px;
  padding: 0 20px !important;
}

:deep(.el-menu--collapse) {
  width: 64px;
}

:deep(.el-menu--collapse .el-submenu__title) {
  padding: 0 !important;
  text-align: center;
}

:deep(.el-menu--collapse .el-submenu__title i) {
  margin: 0;
  font-size: 20px;
}

:deep(.el-menu--popup) {
  min-width: 200px;
  background-color: #1e2132 !important;
}

:deep(.el-menu--popup .el-menu-item) {
  background-color: #1e2132;
  color: #fff;
}

:deep(.el-menu--popup .el-menu-item:hover) {
  background-color: #2a2f45;
}

:deep(.el-menu--popup .el-menu-item.is-active) {
  color: #409EFF;
}

.vc-menu {
  border-right: 1px solid #EFEFF0;

  .vc-menu-main {
    background-color: #FFFFFF;
    color: #838A9B;
    text-align: center;
    width: 80px;
    font-size: 14px;
    height: calc(100vh - 60px);
    overflow-x: hidden;
    overflow-y: auto;
  }

  .vc-menu-main::-webkit-scrollbar {
    width: 6px;
  }

  .vc-menu-main::-webkit-scrollbar-thumb {
    background: #c0c4cc;
    border-radius: 3px;
  }

  .vc-menu-main::-webkit-scrollbar-track {
    background: transparent;
  }

  ul {
    padding-inline-start: 0px;
    margin: 0;
    padding: 0;
  }

  li {
    margin: 0;
    padding: 0;
  }

  .vc-menu-main .active {
    background-color: #6CABE0;
    color: #FFFFFF;
  }
}

.moreCommunity {
  font-weight: 600;
  color: #212529;
  font-size: 12px;
}

.vc-menu-main ul li {
  height: 45px;
  line-height: 45px;
  cursor: pointer;
  list-style-type: none;
}

.vc-menu-main ul li:hover {
  background-color: #3E77FC;
  color: #FFFFFF;
}

.vc-menu-main ul li.title {
  color: #FFFFFF;
  height: 60px;
  font-size: 24px;
  line-height: 60px;
}

.vc-menu-main ul li.title a {
  text-decoration: none;
  cursor: pointer;
  color: #FFFFFF;
}

.vc-menu-sub {
  background-color: #FFFFFF;
  color: #545761;
  text-align: start;
  width: 110px;
  font-size: 14px;
  height: calc(100vh - 60px);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.vc-menu-sub-title {
  flex-shrink: 0;
  color: #4F525C;
  height: 40px;
  font-size: 14px;
  line-height: 40px;
  text-align: center;
  border-bottom: 1px solid #F2F2F3;
}

.vc-menu-sub-body {
  flex: 1;
  min-height: 0;
  overflow-x: hidden;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: #c0c4cc transparent;
}

.vc-menu-sub-body::-webkit-scrollbar {
  width: 6px;
}

.vc-menu-sub-body::-webkit-scrollbar-thumb {
  background: #c0c4cc;
  border-radius: 3px;
}

.vc-menu-sub-body::-webkit-scrollbar-track {
  background: transparent;
}

.vc-menu-sub-footer {
  flex-shrink: 0;
  height: 40px;
  line-height: 40px;
  background-color: #F6F6F7;
  text-align: center;
  cursor: pointer;
  border-top: 1px solid #EFEFF0;
}

.vc-menu-sub .active {
  background-color: #6CABE0;
  color: #FFFFFF;
}

.vc-menu-sub-body ul li {
  height: 40px;
  line-height: 40px;
  padding-left: 15px;
  cursor: pointer;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.vc-menu-sub-body ul li:hover {
  background-color: #6CABE0;
  color: #FFFFFF;
}
</style>
